export const infoPanelActionTypes = {
    INFO_PANEL_SET_ASSET: 'INFO_PANEL_SET_ASSET',
    INFO_PANEL_SET_ROTATION: 'INFO_PANEL_SET_ROTATION',
    

    INFO_PANEL_ASSET_UPDATE_REQUEST: 'INFO_PANEL_ASSET_UPDATE_REQUEST',
    INFO_PANEL_ASSET_UPDATE_SUCCESS: 'INFO_PANEL_ASSET_UPDATE_SUCCESS',
    INFO_PANEL_ASSET_UPDATE_FAIL: 'INFO_PANEL_ASSET_UPDATE_FAIL',
    INFO_PANEL_ASSET_UPDATE_REQUEST_DISC: 'INFO_PANEL_ASSET_UPDATE_REQUEST_DISC',
   INFO_PANEL_ASSET_UPDATE_REQUEST_ALBUM: 'INFO_PANEL_ASSET_UPDATE_REQUEST_ALBUM'

};


// WEBPACK FOOTER //
// ./src/infoPanel/actions/infoPanel-action-types.js